import { render, staticRenderFns } from "./ConfigWebsiteCatalogueCollectionsConfig.vue?vue&type=template&id=5940b5a9"
import script from "./ConfigWebsiteCatalogueCollectionsConfig.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteCatalogueCollectionsConfig.vue?vue&type=script&lang=js"
import style0 from "./ConfigWebsiteCatalogueCollectionsConfig.vue?vue&type=style&index=0&id=5940b5a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports